import React from "react";

import { Button } from "rhombus-react";
import Permissioned from "widgets/Permissioned";
import { useSelector } from "react-redux";
import { IMPORT_EXPORT_ACTIONS_LIST } from "widgets/grid/cells/CreativeActionLists/VersionActions";
import { importExportActions } from "widgets/grid/cells/VersionActionLists/ImportExportActions";
import { importExportVersionsAllowables } from 'utils/VersionActions';
import { getManualClassificationEnabled } from "selectors/Intelligence";
import { usePredictiveScoringEnabled } from "hooks/usePredictiveScoringEnabled";
import { PREDICTIVE_SCORING_VERSIONS_EXPORT_LIST } from "widgets/actions/ExportPredictiveScore";
import { isScoringSupportedAdType } from "widgets/actions/PredictiveScoringAction";
import { TAXONOMY_VERSIONS_IMPORT_EXPORT_ACTIONS_LIST } from "widgets/actions/bulk/Taxonomy";
import { buildDropdownList } from "widgets/actions/bulk/Social";
import { MENU_DIVIDER } from "utils/constants";
import { hasPermission } from "utils/common";

export default function ImportExportButton(){
	let { user, dependentValues, canClassify } = useSelector((state)=>{
			return {
				user:state.you,
				dependentValues: {
					...state.creativeVersions,
					creativeId: state.creativeDetails?.id,
					dynamicTarget: state.creativeDetails?.dynamicTarget,
					creativeDetails: state.creativeDetails,
					libraryId: state.libraryProperties?.id,
					adType: state.creativeDetails.adType,
					origin: state.creativeDetails.origin,
					html5Meta: state.creativeDetails.html5Meta,
					selectedVersionIds: state.selected?.versions,
				},
				canClassify: getManualClassificationEnabled(state) && hasPermission(state.you, "Creative Library", "Edit"),
			};
		})
		, actions = importExportActions(IMPORT_EXPORT_ACTIONS_LIST, { user, dependentValues })
		, taxonomyActions = []
		;

	const isPredictiveScoringOn = usePredictiveScoringEnabled();

	if (canClassify) {
		// Used buildDropdownList() since importExportActions() was adding a divider
		taxonomyActions = buildDropdownList([TAXONOMY_VERSIONS_IMPORT_EXPORT_ACTIONS_LIST], dependentValues);
		if (actions.length) {
			taxonomyActions.unshift(MENU_DIVIDER);
		}
	}

	// Only offer the predictive-score export where scoring is actually supported for this creative's
	// ad type — otherwise the action showed up on ineligible libraries (e.g. audio), exporting nothing.
	const isScoringSupported = isScoringSupportedAdType(dependentValues.adType);

	let predictiveScoringActions = [];
	if (isPredictiveScoringOn && isScoringSupported) {
		predictiveScoringActions = buildDropdownList([PREDICTIVE_SCORING_VERSIONS_EXPORT_LIST], dependentValues);
		if (actions.length || taxonomyActions.length) {
			predictiveScoringActions.unshift(MENU_DIVIDER);
		}
	}

	return (
		<Permissioned any={importExportVersionsAllowables}>
			<Button
				key="import-export"
				icon="download"
				style="block"
				theme="default"
				isDropDown
				splitActions={[...actions, ...taxonomyActions, ...predictiveScoringActions]}
				splitValue="import-export-button">
				Import/Export
			</Button>
		</Permissioned>
	);
}

ImportExportButton.displayName = "ImportExportButton";
